import { Component, OnInit } from '@angular/core';
import { ICourse, CourseArea } from 'src/app/models/course.model';
import { BehaviorSubject } from 'rxjs';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.scss']
})
export class TrainingComponent implements OnInit {
  courses: ICourse[];
  filteredCourses: BehaviorSubject<ICourse[]>;
  selectedArea: CourseArea;

  constructor(private title: Title) { }

  get courseAreas() { return CourseArea; }

  private filterCourses(): void {
    const courses = this.courses.filter(course => course.area === this.selectedArea);
    this.filteredCourses.next(courses);
  }

  ngOnInit(): void {
    this.title.setTitle('Capacitación - CCCISA');
    // tslint:disable: max-line-length
    this.courses = [
      { code: 'CA-1', description: 'Plática informativa de los cambios de la norma ISO 9001 de la versión 2008 a la 2015', area: CourseArea.management },
      { code: 'CA-2', description: 'Taller para la actualización de un sistema de gestión de calidad ISO 9001 de la versión 2008 a la 2015', area: CourseArea.management },
      { code: 'CA-3', description: 'Introducción a los sistemas de gestión de la calidad ISO 9001:2015', area: CourseArea.management },
      { code: 'CA-4', description: 'Cómo implementar un sistema de gestión de la calidad ISO 9000 en instituciones de gobierno.', area: CourseArea.management },
      { code: 'CA-5', description: 'Taller para el desarrollo de la documentación de un Sistema de Gestión', area: CourseArea.management },
      { code: 'CA-6', description: 'Taller para la formación de auditores internos en sistemas de gestión de la calidad ISO', area: CourseArea.management },
      { code: 'CA-7', description: 'Taller para la formación de auditores internos en sistemas integrales ISO 9001, 14001 y OHSAS 18001.', area: CourseArea.management },
      { code: 'CA-8', description: 'Taller para la actualización de auditores internos en sistemas de gestión de la calidad ISO 9000 versión 2015', area: CourseArea.management },
      { code: 'CA-9', description: 'Técnicas y herramientas para la mejora continúa.', area: CourseArea.management },
      { code: 'CA-10', description: 'Taller para la implantación de un sistema de gestión en laboratorios de ensayo y calibración bajo la norma NMX-EC-17025-IMNC-2006 ISO/IEC 17025:2005.', area: CourseArea.management },
      { code: 'CA-11', description: 'Taller para la formación de auditores internos para laboratorios de ensayo y calibración ISO 17025.', area: CourseArea.management },
      { code: 'CA-12', description: 'Taller de actualización de la norma ISO 17025 (NUEVO)', area: CourseArea.management },
      { code: 'CA-13', description: 'Cómo establecer indicadores de medición y objetivos de calidad en su organización', area: CourseArea.management },
      { code: 'CA-14', description: 'Calidad en el servicio.', area: CourseArea.management },
      { code: 'CA-15', description: 'Administración de procesos', area: CourseArea.management },
      { code: 'CA-16', description: 'Estadística para la calidad.', area: CourseArea.management },
      { code: 'CA-17', description: 'Introducción a los sistemas de gestión ambiental ISO 14001.', area: CourseArea.management },
      { code: 'CA-18', description: 'Introducción a la norma ISO 45001', area: CourseArea.management },
      { code: 'CA-19', description: 'Introducción a la gestión de Riesgos de acuerdo a la norma ISO 31010. (NUEVO) para la actualización de un sistema de gestión de calidad ISO 9001 de la versión 2008 a la 2015', area: CourseArea.management },
      { code: 'CA-20', description: 'El enfoque a procesos y análisis de riesgos en los laboratorios de ensayo y calibración (NUEVO)', area: CourseArea.management },
      { code: 'CA-21', description: 'Taller asesoría para la migración del sistema de gestión de los laboratorios de ensayo y calibración de la norma ISO 17025:2005 (NMX-EC-17025-IMNC-2006) a la versión ISO 17025:2017 (NUEVO)', area: CourseArea.management },
      { code: 'ME-1', description: 'Introducción a la metrología.', area: CourseArea.metrology },
      { code: 'ME-2', description: 'Curso básico para el cálculo de las incertidumbres en las mediciones.', area: CourseArea.metrology },
      { code: 'ME-3', description: 'Calibración de instrumentos de medición de presión.', area: CourseArea.metrology },
      { code: 'ME-4', description: 'Calibración de instrumentos de medición de temperatura.', area: CourseArea.metrology },
      { code: 'ME-5', description: 'Calibración de instrumentos de medición de temperatura y humedad.', area: CourseArea.metrology },
      { code: 'ME-6', description: 'Calibración de instrumentos para pesar.', area: CourseArea.metrology },
      { code: 'ME-7', description: 'Buenas prácticas de laboratorio.', area: CourseArea.metrology },
      { code: 'RH-1', description: 'Cómo mejorar y reforzar mi trabajo en equipo.', area: CourseArea.humanResources },
      { code: 'RH-2', description: 'Mejorando mi relación conmigo mismo y con los demás en el trabajo.', area: CourseArea.humanResources },
      { code: 'RH-3', description: 'El arte de hablar en público.', area: CourseArea.humanResources }
    ];

    this.selectedArea = CourseArea.management;
    const initialCourses = this.courses.filter(course => course.area === this.selectedArea);
    this.filteredCourses = new BehaviorSubject<ICourse[]>(initialCourses);
  }

  selectArea(area: CourseArea) {
    this.selectedArea = area;
    this.filterCourses();
  }
}
